import moment from "moment";

/**
 * Formats a UTC date string to local time in "MMM DD, YYYY" format.
 * @param {string|Date} date
 * @returns {string}
 */
export function formatUtcDateToLocal(date) {
    if (!date) return "";
    return moment.utc(new Date(date)).add(-moment().utcOffset(), "minutes").format("MMM DD, YYYY");
}
